import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { experimentApi } from './api'
import { logicalSubmit } from './form-schema.mjs'
export const useExperimentStore = defineStore('experiment', () => {
  const participant = ref(null), record = ref(null), busy = ref(false), error = ref('')
  const operation = logicalSubmit()
  const allowedActions = computed(() => participant.value?.allowed_actions || [])
  const revision = computed(() => participant.value?.revision)
  async function loadParticipation(id) {
    const data = await experimentApi(`participants/${id}`)
    participant.value = data.participant; record.value = data.record
    return data
  }
  async function refresh() { return loadParticipation(participant.value.id) }
  async function mutate(suffix, body) {
    if (busy.value) throw new Error('Please wait for the current request.')
    busy.value = true; error.value = ''
    const path = `participants/${participant.value.id}/${suffix}`
    try { return await operation.run(path, body, request_id => experimentApi(path, { ...body, request_id })) }
    catch (e) { error.value = e.status === 409 ? `${e.message} Reload the saved state before continuing.` : e.message; throw e }
    finally { busy.value = false }
  }
  async function saveMeasurement(kind, answers, submit) {
    await mutate(`measurements/${kind}`, { answers, submit, revision: revision.value })
    await refresh()
  }
  return { participant, record, busy, error, allowedActions, revision, loadParticipation, refresh, mutate, saveMeasurement }
})
